// extracted by mini-css-extract-plugin
export var image = "image-module--image--d06e5";
export var wrapper = "image-module--wrapper--13e0f";